export const MAIL_MAGAZINE_OPTIONS = [
  {
    category: "subscribed_to_project",
    label: "新着案件",
  },
  {
    category: "subscribed_to_useful_info",
    label: "お役立ち情報",
  },
  {
    category: "subscribed_to_notice",
    label: "お知らせ",
  },
];
